<div class="row mt-4">
  <div class="col-3 fixed-width-button mb-4">
    <div class="form-group has-float-label">
      <input
        jniAutoCompleteBlocker
        name="manager"
        type="text"
        class="form-control"
        id="manager"
        [(ngModel)]="manager"
        disabled />
      <label class="form-label">Manager</label>
    </div>
  </div>
  <div class="col-3 fixed-width-button mb-4">
    <div class="form-group has-float-label">
      <input
        jniAutoCompleteBlocker
        name="bc"
        type="text"
        class="form-control"
        id="bc"
        [(ngModel)]="bc"
        disabled />
      <label class="form-label">BC</label>
    </div>
  </div>
</div>

<div class="row mt-3">
  <div class="col-12 fixed-width-button mb-4">
    <div class="has-float-label">
      <textarea
        jniAutoCompleteBlocker
        name="notes"
        type="text"
        class="form-control"
        [(ngModel)]="notes"
        [maxLength]="3000"></textarea>
      <label class="form-label">Notes</label>
    </div>
  </div>
</div>

<div class="row mt-3">
  <div class="d-flex justify-content-end col-12">
    <button
      class="col-1 btn btn btn-primary me-3"
      type="submit"
      (click)="onSubmit()">
      Submit
    </button>
    <button
      class="col-1 btn btn btn-primary me-3"
      type="submit"
      (click)="onCancel()">
      Cancel
    </button>
  </div>
</div>
